/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Default_Accessorials_TitleInputs */

const en_default_accessorials_title = /** @type {(inputs: Default_Accessorials_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default Accessorials`)
};

const es_default_accessorials_title = /** @type {(inputs: Default_Accessorials_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargos adicionales predeterminados`)
};

/**
* | output |
* | --- |
* | "Default Accessorials" |
*
* @param {Default_Accessorials_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const default_accessorials_title = /** @type {((inputs?: Default_Accessorials_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Default_Accessorials_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_default_accessorials_title(inputs)
	return es_default_accessorials_title(inputs)
});